import { getConfig } from '../configs/service'

const LOG_LEVELS = {
  ERROR: 0,
  WARN: 1,
  INFO: 2,
  DEBUG: 3
}

const DEFAULT_LOG_LEVEL = 'INFO'

const getLogLevel = () => {
  const envLogLevel = getConfig()?.VUE_APP_LOG_LEVEL || process.env?.VUE_APP_LOG_LEVEL
  const logLevelName = envLogLevel || DEFAULT_LOG_LEVEL
  const normalizedLevel = logLevelName.toUpperCase()

  return LOG_LEVELS[normalizedLevel] !== undefined
    ? LOG_LEVELS[normalizedLevel]
    : LOG_LEVELS.INFO
}

class Logger {
  static error(message, data) {
    if (getLogLevel() >= LOG_LEVELS.ERROR) {
      console.error(`[ERROR] ${message}`, data !== undefined ? data : '')
    }
  }

  static warn(message, data) {
    if (getLogLevel() >= LOG_LEVELS.WARN) {
      console.warn(`[WARN] ${message}`, data !== undefined ? data : '')
    }
  }

  static info(message, data) {
    if (getLogLevel() >= LOG_LEVELS.INFO) {
      console.info(`[INFO] ${message}`, data !== undefined ? data : '')
    }
  }

  static debug(message, data) {
    if (getLogLevel() >= LOG_LEVELS.DEBUG) {
      console.log(`[DEBUG] ${message}`, data !== undefined ? data : '')
    }
  }
}

export default Logger
